<div class="conatiner" fxLayout="column" fxLayoutAlign="start center">
  <div fxFlexAlign="end">
    <label (click)="close()" class="close"></label>
  </div>
  <img class="logo" src="assets/img/sidebar-menu/docformative-logo.svg" alt="Docformative" />
  <div fxLayout="row wrap" fxLayoutAlign="center center">
    <p fxFlex="100">Physician web app and Android version are coming soon.</p>
    <p fxFlex="100">Please use our mobile app.</p>
  </div>
  <a href="https://apps.apple.com/us/app/docformative/id1472933856" target="_blank" rel="noopener">
    <img src="assets/img/home/common/app-store-icon.png" alt="app store" />
  </a>
</div>
